import { useQuery } from "@tanstack/react-query";
import { QueryEstimatedCostDto } from "../types";
import { getEstimatedCost, getSupportedPropertyTypes } from "../api/listing";

export const useEstimatedCost = (
  params: QueryEstimatedCostDto,
  enabled: boolean = true
) => {
  const query = useQuery({
    enabled,
    queryKey: ["estimatedCost", params],
    queryFn: async ({ signal }) => {
      if (!params.compoundId) {
        return undefined;
      }
      const suppportedPropertyTypes = await getSupportedPropertyTypes({
        params: { compoundId: params.compoundId },
        signal,
      });

      const supportedType = suppportedPropertyTypes.data.find(
        (type) => type.id === params.propertyTypeId
      );

      const estimateParams: QueryEstimatedCostDto = {
        compoundId: params.compoundId,
        propertyTypeId: params.propertyTypeId,
        unitArea: params.unitArea,
        landArea: supportedType?.hasLand ? params.landArea : undefined,
        numberOfBedrooms: supportedType?.numberOfBedrooms.includes(
          params.numberOfBedrooms ?? 0
        )
          ? params.numberOfBedrooms
          : undefined,
      };

      return await getEstimatedCost({ params: estimateParams, signal });
    },
  });

  return {
    ...query,
    data: query.data?.data,
  };
};
